import { ApplicationStatus } from 'modules/teams/domain/enums/application-status';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectedStageSelector } from 'modules/championship/store/stages';
import { useChampionship } from './use-championship';
import { useUpsertStage } from './use-upsert-stage';

export const useCheckAcceptedTeams = (championshipId: number) => {
  const upsertStage = useUpsertStage();
  const { data: championship } = useChampionship(championshipId);
  const stage = useSelector(selectedStageSelector);

  useEffect(() => {
    const notAcceptedTeams =
      championship?.applications.filter((team) => {
        return team.status !== ApplicationStatus.ACCEPTED;
      }) ?? [];

    if (notAcceptedTeams.length && stage?.teams.length) {
      const hasNotAcceptedTeams = stage?.teams.some((team) => {
        return notAcceptedTeams.some((t) => t.teamId === team.id);
      });

      if (!hasNotAcceptedTeams) return;

      const teams = stage?.teams.filter((team) => {
        return notAcceptedTeams.some((t) => t.teamId !== team.id);
      });

      upsertStage({
        id: stage.id,
        championshipId: stage.championshipId,
        name: stage.name,
        type: stage.type,
        teamIds: teams.map((team) => team.id),
      });
    }
  }, [stage, championship, upsertStage]);
};

export default useCheckAcceptedTeams;
